export enum statusList {
    New = 0,
    GeneratedInvoice = 1,
    PaidDuePayment = 2,
    AuthenticationReport = 3,
    Active = 4,
    Suspended = 5,
    Expired = 6
}
